const toggleExpanded = (matchId, setData, saveResults) => {
    setData((prev) => {
      if (!prev) return prev;
      const newResults = prev.results.map((result) => {
        const id = result.id;
  
        const updatedMatches = result.Matches.map((matchObj) => {
          const key = Object.keys(matchObj)[0];
          const match = matchObj[key];
  
          if (id !== matchId) return matchObj;
  
          return {
            [key]: {
              ...match,
              expanded: !match.expanded,
            },
          };
        });
  
        return { ...result, Matches: updatedMatches };
      });
  
      saveResults(prev.resultsID, newResults);
      return { ...prev, results: newResults };
    });
  };
  
  export default toggleExpanded;
  